<template>
  <div>
    <el-card class="box-card"
             shadow="nerver">
      <!-- 头部 -->
      <div class="booking-header">
        <!--  -->
        选择服务商：
        <el-select size="mini"
                   clearable
                   v-model="selectOperator"
                   placeholder="请选择"
                   @visible-change="openSelectOperator"
                   @change="changeOperator">
          <el-option v-for="item in options"
                     :key="item.operator_id"
                     :label="item.operator_name"
                     :value="item.operator_id">
          </el-option>
        </el-select>
        <!-- 产品标题 -->
        <div class="booking-search">
          <el-input size="mini"
                    :clearable="true"
                    prefix-icon="el-icon-search"
                    v-model="query"
                    placeholder="请输入产品名称"></el-input>
          <el-button @click="searchKeyWord()"
                     size="mini"
                     type="primary"
                     plain>搜索</el-button>
          <el-button @click="$router.push({ name: 'product_add' })"
                     size="mini"
                     type="primary"
                     icon="el-icon-plus"
                     plain>添加产品</el-button>
        </div>
        <div>筛选区域</div>
        <div>共计：{{ total }}件产品</div>
      </div>
    </el-card>

    <!-- 内容列表 -->
    <div v-loading="loading"
         class="card-prodlist">
      <div class="card-prod"
           v-for="(o, index) in prodinfo"
           :key="index">
        <el-card shadow="hover"
                 :body-style="{ padding: '0px' }">
          <img @click="clickCard(o.spu_id)"
               :src="o.prod_image"
               class="image" />
          <!-- 内容盒子 -->
          <div style="padding: 14px">
            <!-- 产品标题:有2行，超过之后用... 显示 -->
            <div @click="clickCard">
              <h3 style="
                  height: 25px;
                  width: 200px;
                  word-break: keep-all;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  cursor: pointer;
                ">
                {{ o.title }}
              </h3>
              <!-- 服务商 -->
              <div style="color: grey; height: 30px">

                <h4 style="
                          width: 200px; 
                          overflow:hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                          cursor: pointer">
                  <span v-if="o.operator"
                        style="font-size: 5px">服务商：</span> {{ o.operator }}
                </h4>
              </div>
            </div>

            <!-- 目的地 -->
            <div style="margin-top: 10px">
              <span style="font-size: 13px">目的地:</span>

              <el-tag style="margin-left: 5px"
                      v-for="(locitem, index) in o.dest"
                      :key="index"
                      size="mini"
                      type="info">{{ locitem }}</el-tag>
            </div>

            <div class="bottom clearfix">
              <!-- 更新于日期 -->

              <time class="time">更新于: {{ o.updataDate }}</time>

              <el-button @click="makeResveration(o.spu_id, o.title, o.sku_pkg)"
                         type="text"
                         class="button">预定</el-button>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <!-- 容器 -->
    <!-- 下单，预定 的对话框 -->
    <make-resveration ref="makeResveration"
                      :sku_list="sku_list"
                      :spu_id="spu_id"
                      :spu_title="spu_title"
                      :showMakeResverationDialog.sync="dialogFormVisible"></make-resveration>
    <!-- 页码 -->
    <div class="pagination">
      <el-card shadow="nerver">
        <el-pagination @current-change="handleCurrentChange"
                       :current-page="pagenum"
                       :page-size="pagesize"
                       :total="total"
                       :small="true"
                       background
                       layout="prev, pager, next,slot">
          <span style="margin-left: 5px; cokor: #606266">共：{{ pagecount }} 页</span>
        </el-pagination>
      </el-card>
    </div>
  </div>
</template>

<script>
import makeResveration from '../booking/MakeResveration'
export default {
  name: 'Product',
  components: { 'make-resveration': makeResveration },
  data() {
    return {
      loading: true,
      dialogFormVisible: false,
      pagenum: 1,
      pagesize: 12,
      //页数
      pagecount: -1,
      // 总数量
      total: -1,
      query: '',
      prodinfo: [
        {
          dest: '等待中',
          operator: '等待中',
          prod_image: '',
          title: '等待中',
          updataDate: '等待中',
        },
        {
          dest: '等待中',
          operator: '等待中',
          prod_image: '',
          title: '等待中',
          updataDate: '等待中',
        },
        {
          dest: '等待中',
          operator: '等待中',
          prod_image: '',
          title: '等待中',
          updataDate: '等待中',
        },
        {
          dest: '等待中',
          operator: '等待中',
          prod_image: '',
          title: '等待中',
          updataDate: '等待中',
        },
        {
          dest: '等待中',
          operator: '等待中',
          prod_image: '',
          title: '等待中',
          updataDate: '等待中',
        },
        {
          dest: '等待中',
          operator: '等待中',
          prod_image: '',
          title: '等待中',
          updataDate: '等待中',
        },
        {
          dest: '等待中',
          operator: '等待中',
          prod_image: '',
          title: '等待中',
          updataDate: '等待中',
        },
        {
          dest: '等待中',
          operator: '等待中',
          prod_image: '',
          title: '等待中',
          updataDate: '等待中',
        },
      ],
      sku_list: [],
      spu_id: 0,
      spu_title: '',
      test: this.$ip,
      options: [], // 服务商选项
      selectOperator: [], // 选择后的服务商
    }
  },
  created() {
    this.getProdInfo()
  },
  methods: {
    searchKeyWord() {
      this.pagenum = 1
      this.getProdInfo()
    },
    // openSelectOperator 搜索服务商
    openSelectOperator() {
      this.$http.get(`/product/get_operator_list`).then((res) => {
        this.options = res.data.data
      })
    },
    // 选择中服务商
    changeOperator() {
      console.log(this.selectOperator)
      this.getProdInfo()
    },
    // 分页处理
    handleCurrentChange(val) {
      this.loading = true
      this.prodinfo = [{}, {}, {}, {}, {}, {}, {}]
      this.pagenum = val
      this.getProdInfo()
      window.scrollTo(0, 0)
    },
    // 获取产品列表信息
    getProdInfo() {
      this.loading = true
      this.$http
        .get(
          `/product/get_product_list?operator_id=${this.selectOperator}&p_no=${this.pagenum}&p_size=${this.pagesize}&key_word=${this.query}`
        )
        .then((res) => {
          console.log(res)
          const { data, errno, errmsg } = res.data
          this.pagecount = res.data.pages
          this.total = res.data.product_account
          this.prodinfo = []
          if (data.length !== 0) {
            for (let pro of data) {
              // 建立对象，并将对象 push到列表
              let item = {}
              item.spu_id = pro.spu_id
              item.title = pro.spu_name
              item.updataDate = pro.last_update_time
              item.prod_image = pro.spu_avatar
              item.dest = pro.dest
              item.operator = pro.operator
              this.prodinfo.push(item)
              // console.log(this.prodinfo);
              // 套餐名称，和id，添加到列表中
              item.sku_pkg = pro.sku
              this.loading = false
            }
          } else {
            this.loading = false
          }
          //console.log(this.prodinfo);
        })
    },
    //点击产品卡片 进入介绍页
    clickCard(spu_id) {
      // this.$router.push({ path: `/product-inrto` });
      // this.$router.push({
      //   path: `/product-intro`,
      //   query: { spu_id: `${spu_id}` },
      // })
      // this.$router.push({
      //   name: "priduct_introduce",
      //   params: {
      //     id: spu_id
      //   }
      // });

      const newpage = this.$router.resolve({
        path: '/product-intro',
        query: {
          spu_id: spu_id,
        },
      })
      window.open(newpage.href, '_blank')

      // 将skuid 发送给 product-inrto
    },
    // 打开 下单对话框 【点击预定按钮 方案二】
    makeResveration(id, title) {
      // 第一个if 判断 组件是否渲染
      if (this.$refs.makeResveration) {
        // 第二个if 判断点击的id 是否等于之前的ID，如果不等于就清空上次的数据
        if (this.$refs.makeResveration.spu_id !== id) {
          // this.$refs.makeResveration.$refs.TimeInput.time = "";
          // console.log(this.$refs.makeResveration.$refs);
          if (Object.keys(this.$refs.makeResveration.$refs).length !== 0) {
            this.$refs.makeResveration.$refs.TimeInput.time = ''
          }
          this.$refs.makeResveration.selectPkgId = ''
          this.$refs.makeResveration.choiceData = ''
          this.$refs.makeResveration.selectTime = ''
          this.$refs.makeResveration.price_type_list = [
            { type: '成人', type_info: '', num: 0, id: 1 },
            { type: '儿童', type_info: '', num: 0, id: 2 },
          ]
          this.$refs.makeResveration.inputContect = ''
          this.$refs.makeResveration.inputPhone = ''
          this.$refs.makeResveration.inputEmail = ''
          this.$refs.makeResveration.inputPickUp = ''
          this.$refs.makeResveration.inputSource = ''
          this.$refs.makeResveration.inputBookingNum = ''
          this.$refs.makeResveration.sku_additions_list = []
          this.$refs.makeResveration.selectAdditionId = []
          this.$refs.makeResveration.select_addition = false
          this.$refs.makeResveration.template_items = []
        }
      }
      // initMakeResveration();
      this.$http.get(`/product/get_product?spu_id=${id}`).then((res) => {
        // console.log(res);
        this.dialogFormVisible = true
        this.sku_list = res.data.data.skus
        this.spu_id = id
        this.spu_title = title
        this.$refs.makeResveration.loading = false
        this.$refs.makeResveration.getBookingNumber()
      })
    },

    closeDialog(id) {},
  },
}
</script>

<style>
.booking-search {
  display: flex;
  float: right;
}

.booking-search button {
  margin-left: 10px;
}

.box-card {
  height: auto;
}

/* 卡片列表 */
.card-prodlist {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
}

.card-prod {
  margin-top: 10px;
  margin-bottom: 10px;
  margin-right: 10px;
  margin-left: 10px;
  /* cursor 光标属性，可以添加click事件 */
}

.pagination {
  width: 100%;
  position: flex;
  float: right;
  margin-top: 10px;
  text-align: right;
}

/* 卡片内容 */
.time {
  font-size: 13px;
  color: #999;
}

/* 下单的对话框 圆角矩形*/
.el-dialog {
  border-radius: 10px;
}

/* 修改日期颜色和字体大小 */

.bottom {
  margin-top: 13px;
  line-height: 20px;
}

.button {
  padding: 0;
  float: right;
}

.image {
  width: 235px;
  height: 235px;
  display: block;
  cursor: pointer;
}

/* 双为闭合，前后各加一个盒子 */
/* 伪元素清楚浮动，创建一个新盒子放在日期和按钮的最后 */
/* content：”“ 伪元素必须有这个属性 */
/* 插入盒子，转为块级元素 table/ block（单伪元素时使用） */
.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}

/* 清楚浮动的核心 */
.clearfix:after {
  clear: both;
}
</style>